// Welle 6a (Gründer, 26. Sep.): deutsche Fassung von golf6App.nl.ts. Tasten von Apple und Google
// so, wie ein deutsches Gerät sie zeigt („Zum Home-Bildschirm", „Hinzufügen", „App installieren").
// Ton: du-Form, kurze Sätze.
export const appGolf6De = {
    tabletGuide: {
        title: 'So verbindest du ein iPad mit dem Board',
        intro: 'Drei Schritte, etwa eine Minute. Lass diese Seite offen.',
        step1Title: 'Öffne Safari auf dem iPad',
        step1Body: 'Tippe diese Adresse in die Adressleiste:',
        copy: 'Kopieren',
        copied: 'Kopiert',
        copyLabel: 'Adresse {url} kopieren',
        step2Title: 'Das Board zeigt einen Code',
        step2Body: 'Acht Zeichen, zum Beispiel ABCD-2345. Lass das iPad so liegen.',
        step3Title: 'Gib den Code hier ein',
        step3Body: 'Wähle auch den Raum, in dem das Board hängt. Das Board erscheint nach ein paar Sekunden.',
        enterCode: 'Code eingeben',
        orTitle: 'Lieber nichts tippen?',
        orBody: 'Erstelle einen QR-Code und scanne ihn mit der Kamera des iPads. Das Board verbindet sich selbst.',
        qrButton: 'Mit QR-Code verbinden',
        tipsTitle: 'Tipps für ein Board an der Wand',
        tips: [
            {
                title: 'Leg das Board auf den Home-Bildschirm',
                body: 'Dann öffnet es sich im Vollbild, ohne Adressleiste. Mach das vor dem Verbinden: Eine App auf dem Home-Bildschirm hat einen eigenen Speicher und wird separat verbunden.',
            },
            {
                title: 'Automatische Sperre: Nie',
                body: 'Einstellungen › Anzeige & Helligkeit › Automatische Sperre › Nie. Lass das iPad am Ladegerät, dann bleibt der Bildschirm an.',
            },
            {
                title: 'Geführter Zugriff',
                body: 'Einstellungen › Bedienungshilfen › Geführter Zugriff (älteres iPad mit iOS 12: Einstellungen › Allgemein › Bedienungshilfen › Geführter Zugriff): einschalten und einen Code wählen. Öffne das Board und drücke dreimal schnell die Home-Taste (oder die obere Taste). So bleiben Kinder im Board.',
            },
            {
                title: 'Einmal tippen für Ton',
                body: 'Ein iPad spielt erst nach einem Tippen Ton ab. Tippe nach dem Start einmal auf das Board, dann hörst du den Adhan und die Aufrufe.',
            },
        ],
        homeScreenHow: 'Wie lege ich es auf den Home-Bildschirm?',
    },
    qr: {
        title: 'Mit QR-Code verbinden',
        intro: 'Das iPad scannt den Code mit der Kamera und verbindet sich selbst. Du musst nichts tippen.',
        room: 'Raum',
        name: 'Name des Tablets',
        defaultName: 'iPad {room}',
        create: 'QR-Code erstellen',
        scanTitle: 'Mit der Kamera des iPads scannen',
        scanSteps: [
            'Öffne die Kamera-App auf dem iPad.',
            'Richte sie auf diesen Code, bis oben eine Mitteilung erscheint.',
            'Tippe auf die Mitteilung. Das Board öffnet sich in Safari und verbindet sich selbst.',
        ],
        validFor: 'Noch {time} gültig · funktioniert einmal',
        qrLabel: 'QR-Code zum Verbinden eines Tablets in {room}',
        waiting: 'Warten, bis das iPad scannt…',
        claimed: '{name} ist verbunden',
        claimedBody: 'Das Board in {room} zeigt jetzt den Kalender.',
        expired: 'Dieser QR-Code ist abgelaufen',
        expiredBody: 'Ein QR-Code funktioniert 10 Minuten und nur einmal. Erstelle einen neuen.',
        again: 'Neuer QR-Code',
        done: 'Fertig',
        safariNote: 'Der QR-Code öffnet das Board in Safari. Liegt das Board schon auf dem Home-Bildschirm? Dann verbinde diese App mit dem Code.',
        keepPrivate: 'Zeig diesen Code niemandem: Wer ihn scannt, bekommt das Board deiner Familie.',
    },
    phoneQr: {
        title: 'AMUMIN auf dem Handy öffnen',
        body: 'Scanne diesen Code mit der Kamera deines Handys. Leg AMUMIN danach auf deinen Home-Bildschirm.',
        label: 'QR-Code zu {url}',
    },
    install: {
        platform: 'Welches Gerät?',
        ios: 'iPhone/iPad',
        android: 'Android',
        desktop: 'Computer',
        thisDevice: '{platform} (dieses Gerät)',
        iosSteps: [
            'Öffne {url} in Safari.',
            'Tippe auf Teilen: das Quadrat mit dem Pfeil nach oben. Auf dem iPhone ist es unten, auf dem iPad oben neben der Adresse. Nicht zu sehen? Tippe zuerst auf ···.',
            'Wische oder scrolle im Teilen-Menü, bis du Zum Home-Bildschirm siehst, und tippe darauf. Auf einem älteren iPad ist es in der unteren Reihe: Wische sie nach links.',
            'Tippe oben rechts auf Hinzufügen.',
            'Öffne {app} ab jetzt mit dem Symbol auf deinem Home-Bildschirm.',
        ],
        androidSteps: [
            'Öffne {url} in Chrome.',
            'Tippe oben rechts auf die drei Punkte.',
            'Wähle App installieren (oder Zum Startbildschirm hinzufügen).',
            'Tippe auf Installieren. {app} ist jetzt bei deinen Apps.',
        ],
        desktopSteps: [
            'Öffne {url} in Chrome oder Edge.',
            'Klicke rechts in der Adressleiste auf das Installationssymbol (ein kleiner Bildschirm mit Pfeil).',
            'Klicke auf Installieren. {app} öffnet sich ab jetzt in einem eigenen Fenster.',
        ],
        ui: {
            share: 'Teilen',
            addToHome: 'Zum Home-Bildschirm',
            add: 'Hinzufügen',
            cancel: 'Abbrechen',
            installApp: 'App installieren',
            install: 'Installieren',
        },
        pictureLabel: 'Beispiel für Schritt {n}',
    },
    stepUp: {
        which: 'Gib dein eigenes AMUMIN-Passwort ein: dasselbe, mit dem du dich auf {host} anmeldest.',
        notThese: 'Also nicht das WLAN-Passwort und nicht den Code des iPads.',
        why: 'Wir fragen bei wichtigen Schritten danach, zum Beispiel beim Verbinden eines Tablets. Danach fragen wir 10 Minuten nicht mehr.',
        account: 'Dein Konto',
        password: 'Dein AMUMIN-Passwort',
        forgot: 'Passwort vergessen?',
    },
    tasks: {
        forWho: 'Für wen?',
        forWhoHint: 'Die Kinder sind schon ausgewählt. Tippe auf einen Namen, um jemanden hinzuzufügen oder zu entfernen.',
        nobody: 'Wähle mindestens eine Person.',
    },
    werklijstDoc: {
        read: 'Empfehlung lesen',
        readLabel: 'Empfehlung lesen: {title}',
        loading: 'Die Empfehlung wird geladen…',
        missing: 'Diese Empfehlung ist in dieser Version der App noch nicht enthalten.',
        error: 'Die Empfehlung kann gerade nicht gelesen werden. Versuch es später noch einmal.',
        back: 'Zurück',
        external: '(öffnet sich in einem neuen Fenster)',
    },
};
//# sourceMappingURL=golf6App.de.js.map